import React, { useState } from 'react';
import { FormContainer } from 'modules/2023-q3/components/forms/components/form-container/form-container';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from 'modules/2023-q3/components/accordion/accordion';
import { ReactComponent as ArrowDropDownIcon } from 'assets/icons/arrows/caret-down.svg';
import { Box, Grid } from '@material-ui/core';
import { Typography, TypographyVariant } from 'components/core';
import { useBankAccounts } from 'hooks/banking/use-bank-accounts';
import { useBusiness } from 'hooks/business/use-business';
import { BankAccount } from 'types';
import { ManualWireForm } from './manual-wire-form/manual-wire-form';

export const ManualWireFormAccordion = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const { data: business } = useBusiness();
  const { data: accounts } = useBankAccounts(business?.Id);

  // ins_12 Fidelity, ins_13 Chase, ins_56 PNC — Plaid masking limits for wire routing.
  // Only prompt for manual wire entry when those Plaid links are not ACH-ready yet.
  // Once PlaidDataReady + healthy status, withdrawals use the same ACH list as deposits.
  const PLAID_SPECIAL_INSTITUTION_IDS = ['ins_12', 'ins_13', 'ins_56'] as const;
  const accountsNeedingManualWireInfo = accounts?.filter(
    (account: BankAccount) =>
      ['checking', 'savings'].includes(account.Type) &&
      account.FinancialDataAggregator === 'PLAID' &&
      !!account.institution?.id &&
      PLAID_SPECIAL_INSTITUTION_IDS.includes(
        account.institution.id as typeof PLAID_SPECIAL_INSTITUTION_IDS[number],
      ) &&
      !(
        account.PlaidDataReady === true && account.PlaidStatus !== 'AUTH_ERROR'
      ),
  );

  const handleAccordionChange = (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean,
  ) => {
    setIsExpanded(isExpanded);
  };

  if ((accountsNeedingManualWireInfo?.length ?? 0) > 0) {
    return (
      <FormContainer>
        <Accordion onChange={handleAccordionChange} expanded={isExpanded}>
          <AccordionSummary expandIcon={<ArrowDropDownIcon />}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item>
                <Grid container alignItems="center">
                  <Grid item>
                    <Box>
                      <Typography
                        color="grey1"
                        variant={TypographyVariant.Paragraph1}
                      >
                        Add Wire Information
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item>
                <Typography
                  color="grey1"
                  variant={TypographyVariant.Paragraph2}
                >
                  Enter your bank account&apos;s wire routing number and account
                  number.
                  <br />
                  <br />
                  <strong>Chase</strong> and <strong>PNC</strong> customers that
                  added their bank accounts with Plaid need to re-enter their
                  account numbers.
                </Typography>
              </Grid>
            </Grid>
          </AccordionSummary>

          <AccordionDetails>
            <Box mt={4}>
              <ManualWireForm setIsExpanded={setIsExpanded} />
            </Box>
          </AccordionDetails>
        </Accordion>
      </FormContainer>
    );
  }

  return null;
};
